module.exports = __webpack_public_path__ + "img/share-scuuess.e41815c0.png";